import script from "./RelationPath.vue?vue&type=script&setup=true&lang=ts"
export * from "./RelationPath.vue?vue&type=script&setup=true&lang=ts"

import "./RelationPath.vue?vue&type=style&index=0&id=14f53490&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14f53490"]])

export default __exports__